import GlobalStoreService from '../services/global-store.service';
import PlatformType from '../enums/PlatformType';

const calculateOptionsPosition = () => {

    // console.log('calculate options')
    if (document.getElementById('main') && document.getElementById('main').scrollHeight > 60) {
        if (document.getElementById('options_scroll_bar')) {
            if (document.getElementById('options_scroll_bar').scrollWidth > document.getElementById('options_scroll_bar').offsetWidth) {
                document.getElementById('options_scroll_bar').style.justifyContent = ''
            }
            else {
                document.getElementById('options_scroll_bar').style.justifyContent = 'center'
            }
        }
        let total_height = document.getElementById('chat_list_id').scrollHeight + (document.getElementById('options_bar_position_id') ? document.getElementById('options_bar_position_id').scrollHeight : 0)
        let fixed_height = document.getElementById('chat_message_id').clientHeight
        // console.log(total_height,fixed_height)
        if (document.getElementById('options_bar_position_id')) {
            if (total_height >= fixed_height) {
                document.getElementById('options_bar_position_id').style.position = 'static'
            }
            else if (total_height < fixed_height) {
                document.getElementById('options_bar_position_id').style.position = 'absolute'
            }
        }
    }
}

const calculateOptionsLeftPosition = () => {
    if (GlobalStoreService.get('platformType') !== PlatformType.WEB && document.getElementsByClassName("choice_list_item") && document.getElementById('options_scroll_bar')) {
        let items = document.getElementsByClassName("choice_list_item")
        // document.getElementById('options_scroll_bar').scrollRight = 56
        let total_width = 0
        if (items && items.length > 0) {

            // items[0].style.paddingLeft = '51px'
            for (let i = 0; i < items.length; i++) {
                total_width = total_width + items[i].offsetWidth + 10
                if (Math.abs(total_width > document.getElementById('options_scroll_bar').offsetWidth)) {
                    items[0].style.paddingLeft = '61px'
                    // document.getElementById('options_scroll_bar').scrollLeft = 50
                    break
                }
            }
        }
    }
}

export { calculateOptionsPosition, calculateOptionsLeftPosition }


// WEBPACK FOOTER //
// ./src/services/UICalculations.service.js